module.exports = __webpack_public_path__ + "static/media/logo-square.7ee6f302.png";